import MyModal from "../../../Common/my-modal/my-modal.component";
import FormComponent from "./form.component";

interface ModalFormProps {
  onClose: () => void;
  onConvert: () => void;
}

const ModalForm = ({ onClose, onConvert }: ModalFormProps) => {
  return (
    <div>
      <MyModal.Body className="p-3">
        <FormComponent />
      </MyModal.Body>

      <MyModal.Footer className="d-flex gap-4 justify-content-end">
        <MyModal.CancelButton onClick={onClose}>
          Cancel
        </MyModal.CancelButton>
        <MyModal.ApplyButton onClick={onConvert}>
          Convert
        </MyModal.ApplyButton>
      </MyModal.Footer>
    </div>
  );
};

export default ModalForm;